import { createContext } from "react";
import KickImage from 'Reuseables/KickImage';

const ShipperContext = createContext({
  ratio: 1,
  currency: ""
});

export default ShipperContext;